<template>
    <svg xmlns="http://www.w3.org/2000/svg" :width="width" height="26">
        <g v-for="period in periods" :key="period.id">
            <rect
                :x="xForTime(period.start)" y="14"
                height="6" :width="widthForPeriod(period)"
                rx="3"
                :fill="color"
                />
            <rect
                v-if="period.start.hour !== 0"
                :x="xForTime(period.start)-5" y="12"
                height="10" width="10"
                :fill="color"
                rx="5" />
            <rect
                v-if="period.end.hour !== 24"
                :x="xForTime(period.end)-5" y="12"
                height="10" width="10"
                :fill="color"
                rx="5" />
            <text
                v-if="period.comment"
                :x="xForComment(period)" y="8"
                text-anchor="middle"
                font-size="8">
                {{ period.comment }}
            </text>

            <text
                v-if="period.start.hour !== 0"
                :x="xForTime(period.start)" y="8"
                text-anchor="middle"
                font-size="8">
                {{ timeString(period.start) }}
            </text>
            <text
                v-if="period.end.hour !== 24"
                :x="xForTime(period.end)" y="8"
                text-anchor="middle"
                font-size="8">
                {{ timeString(period.end) }}
            </text>
        </g>
    </svg>
</template>

<script>
export default {
    props: {
        color: String,
        periods: Array,
        width: {
            type: Number,
            default: 300,
        },
    },
    data: () => ({
    }),
    methods: {
        xForTime: function(time)  {
            const dataMax = 24 * 4
            if (time.hour === 24) {
                return this.width
            }
            let x = 0
            x += time.hour * 4
            x += time.minute / 60
            if (x === 0) {
                return 0
            }
            return this.width / dataMax * x
        },
        widthForPeriod: function(period) {
            const end = this.xForTime(period.end)
            const start = this.xForTime(period.start)
            return end - start
        },
        timeString: function(time) {
            if (time.minute === 0) {
                return `${time.hour}`
            }
            const hour = time.hour
            const minute = time.minute.toString().padStart(2, '0')
            return `${hour}:${minute}`
        },
        xForComment: function(period) {
            const startX = this.xForTime(period.start)
            const width = this.widthForPeriod(period)
            
            return startX + width/2
        },
    },
};
</script>